import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AdminAriza, ArizaData } from '../../../shared/models/static-model/admins.model';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { GeneralService } from '../../../shared/services/general.service';
import { InputFuntionService } from '../../../shared/services/input-funtion.service';
import { InputGeneral } from '../../../shared/inputs/input-general/input-general';
import { MatCheckbox } from '@angular/material/checkbox';
import { InputGeneralCalendarComponent } from '../../../shared/inputs/input-general-calendar/input-general-calendar.component';
import { InputGeneralSelectComponent } from '../../../shared/inputs/input-general-select/input-general-select.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-administrative',
  templateUrl: './administrative.component.html',
  imports: [
    InputGeneral,
    MatCheckbox,
    InputGeneralCalendarComponent,
    InputGeneralSelectComponent,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
  ],
})
export class AdministrativeComponent {
  @Input() quotationId = 0;
  public Customer!: FormGroup;
  public Contract!: FormGroup;
  public Mastrack!: FormGroup;
  public arizaData: ArizaData | null = null;
  public estadosSepomex: {
    description: string;
    id: number;
    value: string;
  }[] = [];
  public coloniesArray: any[] = [];

  constructor(
    private staticPageService: StaticPageService,
    private generalService: GeneralService,
    private inputFuntionService: InputFuntionService,
  ) {
    // CONTACTO CLIENTE
    this.Customer = new FormGroup({
      CONTACTO_NOMBRE: new FormControl(''),
      CONTACTO_PATERNO: new FormControl(''),
      CONTACTO_MATERNO: new FormControl(''),
      TEL: new FormControl(''),
      CONTACTO_EMAIL: new FormControl(''),
      EMAIL_USUARIO_APP: new FormControl('', Validators.email),
      CUENTA: new FormControl(''),
      IS_FACTURAR: new FormControl(false),
    });

    // CONTRATO
    this.Contract = new FormGroup({
      IS_admon: new FormControl(false),
      admon: new FormControl(''),
      IS_CORTE_AUT: new FormControl(false),
      DIAS_CORTE_AUT: new FormControl(''),
      IS_TIMBRAR: new FormControl(false),
      IS_MAIL_PAGOS: new FormControl(false),
      IS_MAIL_PAGOS_ATRASO: new FormControl(false),
      IS_KM_ILIMITED: new FormControl(false),
      IS_GENERA_MORA: new FormControl(false),
      FEC_INI_MORA: new FormControl(''),
      IS_GARANTIA_EXTENDIDA: new FormControl(false),
      GARANTIA_EXTENDIDA: new FormControl(''),
      IS_ENTREGADO: new FormControl(false),
      IS_GARANTIA: new FormControl(false),
      ID_FONDEADOR: new FormControl(''),
      MetodoDePago: new FormControl(''),
      NuM_POLIZA: new FormControl(''),
      N_BALLOON: new FormControl(''),
      NuM_PLACA: new FormControl(''),
      EDO_PLACA: new FormControl(''),
      NUM_PLACA_OLD: new FormControl(''),
      EDO_PLACA_OLD: new FormControl(''),
    });

    // MASTRACK / Datos adicionales
    this.Mastrack = new FormGroup({
      AliasMastrack: new FormControl(''),
      SerieMastrack: new FormControl(''),
      ModeloMastrack: new FormControl(''),

      aP_PATERNO: new FormControl(''),
      aP_MATERNO: new FormControl(''),
      nombre: new FormControl(''),

      callE_NUM: new FormControl(''),
      c_P: new FormControl(''),
      colonia: new FormControl(''),
      delegacion: new FormControl(''),
      ciudad: new FormControl(''),
      estado: new FormControl(''),

      tel: new FormControl(''),
      teL2: new FormControl(''),
      email: new FormControl('', Validators.email),
    });
    this.getColoniesByPostalCode();
  }

  ngOnInit(): void {
    this.getAdminInitData();
    this.generalService.getEstadosSepomex().subscribe((ress) => (this.estadosSepomex = ress));
  }

  public getColoniesByPostalCode(): void {
    this.Contract.get('cp')?.valueChanges.subscribe((ress: string) => {
      if (ress?.length === 5) {
        this.inputFuntionService
          .getColoniesByPostalCode({ postalCode: ress })
          .subscribe((result) => {
            if (!result) return;

            // ✅ Llena ciudad
            if (result.ciudad) {
              this.Contract.get('ciudad')?.setValue(result.ciudad);
              this.Contract.get('ciudad')?.markAsDirty();
              this.Contract.get('ciudad')?.markAsTouched();
            }

            // ✅ Llena delegación/municipio
            if (result.delegacion) {
              this.Contract.get('delegacion')?.setValue(result.delegacion);
              this.Contract.get('delegacion')?.markAsDirty();
              this.Contract.get('delegacion')?.markAsTouched();
            }

            // ✅ Llena estado
            if (result.estado) {
              this.Contract.get('estado')?.setValue(result.estado);
              this.Contract.get('estado')?.markAsDirty();
              this.Contract.get('estado')?.markAsTouched();
            }

            // ✅ Llena lista de colonias (si hay componente select)
            if (Array.isArray(result.colonies) && result.colonies.length > 0) {
              this.coloniesArray = result.colonies.map((c: any) => ({
                value: c.value,
                description: c.description,
              }));
            }
          });
      }
    });
  }

  public getAdminInitData(): void {
    this.staticPageService.getAdminInitData(this.quotationId).subscribe((ress) => {
      if (!ress) return;
      this.arizaData = ress;

      // CLIENTE
      this.Customer.patchValue({
        CONTACTO_NOMBRE: ress.cliente.contactO_NOMBRE,
        CONTACTO_PATERNO: ress.cliente.contactO_PATERNO,
        CONTACTO_MATERNO: ress.cliente.contactO_MATERNO,
        TEL: ress.cliente.tel,
        CONTACTO_EMAIL: ress.cliente.contactO_EMAIL,
        EMAIL_USUARIO_APP: ress.cliente.appUserEmail,
        CUENTA: ress.cliente.cuenta,
        IS_FACTURAR: ress.cotizacion.iS_FACTURAR,
      });

      // CONTRATO
      this.Contract.patchValue({
        IS_admon: ress.cotizacion.iS_admon,
        admon: ress.cotizacion.admon,
        IS_CORTE_AUT: ress.cotizacion.iS_CORTE_AUT,
        DIAS_CORTE_AUT: ress.cotizacion.diaS_CORTE_AUT,
        IS_TIMBRAR: ress.cotizacion.iS_TIMBRAR_COTIZACION,
        IS_MAIL_PAGOS: ress.cotizacion.iS_MAIL_PAGOS,
        IS_MAIL_PAGOS_ATRASO: ress.cotizacion.iS_MAIL_PAGOS_ATRASO,
        IS_KM_ILIMITED: !ress.cotizacion.iS_KM_ILIMITED,
        IS_GENERA_MORA: ress.cotizacion.iS_GENERA_MORA,
        FEC_INI_MORA: ress.cotizacion.feC_INI_MORA,
        IS_GARANTIA_EXTENDIDA: ress.cotizacion.iS_GARANTIA_EXTENDIDA,
        GARANTIA_EXTENDIDA: ress.cotizacion.garantiA_EXTENDIDA,
        IS_ENTREGADO: ress.cotizacion.iS_ENTREGADO,
        IS_GARANTIA: ress.cotizacion.iS_GARANTIA,
        ID_FONDEADOR: ress.cotizacion.iD_FONDEADOR,
        MetodoDePago: ress.cotizacion.metodoDePago,
        NuM_POLIZA: ress.cotizacion.nuM_POLIZA,
        N_BALLOON: ress.cotizacion.n_BALLOON,
        NuM_PLACA: ress.cotizacion.nuM_PLACA,
        EDO_PLACA: ress.cotizacion.edO_PLACA,
        NUM_PLACA_OLD: ress.cotizacion.nuM_PLACA_OLD,
        EDO_PLACA_OLD: ress.cotizacion.edO_PLACA_OLD,
      });

      // MASTRACK / ARIZA
      this.Mastrack.patchValue({
        AliasMastrack: ress.ariza.aliaS_MASTRACK,
        SerieMastrack: ress.ariza.seriE_MASTRACK,
        ModeloMastrack: ress.ariza.modelO_MASTRACK,
        aP_PATERNO: ress.ariza.aP_PATERNO,
        aP_MATERNO: ress.ariza.aP_MATERNO,
        nombre: ress.ariza.nombre,
        callE_NUM: ress.ariza.callE_NUM,
        c_P: ress.ariza.c_P,
        colonia: ress.ariza.colonia,
        delegacion: ress.ariza.delegacion,
        ciudad: ress.ariza.ciudad,
        estado: ress.ariza.estado,
        tel: ress.ariza.tel,
        teL2: ress.ariza.teL2,
        email: ress.ariza.email,
      });

      [this.Customer, this.Contract, this.Mastrack].forEach((group) => {
        Object.keys(group.controls).forEach((key) => {
          if (key !== 'c_P') {
            // Código postal no se marca como pristine
            group.get(key)?.markAsPristine();
            group.get(key)?.markAsUntouched();
          }
        });
      });
    });
  }

  private buildUpdateRequests(idCotizacion: number): Observable<any>[] {
    const observables: Observable<any>[] = [];

    Object.keys(this.Contract.controls).forEach((key) => {
      const control = this.Contract.get(key);
      const valor = control?.value;
      if (control?.dirty && valor !== null && valor !== undefined) {
        const idUsuario = this.arizaData?.cotizacion.iD_CLIENTE;
        if (idUsuario !== undefined) {
          const body = {
            campo: key,
            idCotizacion,
            idUsuario,
            valor: String(valor),
          };
          observables.push(this.staticPageService.updateAdminData(body));
        }
      }
    });

    Object.keys(this.Customer.controls).forEach((key) => {
      const control = this.Customer.get(key);
      const valor = control?.value;
      if (control?.dirty && valor !== null && valor !== undefined) {
        const idCliente = this.arizaData?.cotizacion.iD_CLIENTE || 0;
        if (control?.dirty && valor !== null && valor !== undefined && idCliente !== undefined) {
          const body = {
            fieldName: key,
            idCotizacion,
            idCliente, // Ensure idCliente is not undefined
            value: String(valor),
          };
          observables.push(this.staticPageService.updateAdminClientData(body));
        }
      }
    });

    const body: AdminAriza = {
      aliasMastrack: this.Mastrack.get('AliasMastrack')?.value,
      serieMastrack: this.Mastrack.get('SerieMastrack')?.value,
      modeloMastrack: this.Mastrack.get('ModeloMastrack')?.value,

      apPaterno: this.Mastrack.get('aP_PATERNO')?.value,
      apMaterno: this.Mastrack.get('aP_MATERNO')?.value,
      nombre: this.Mastrack.get('nombre')?.value,

      calleNum: this.Mastrack.get('callE_NUM')?.value,
      cp: this.Mastrack.get('c_P')?.value,
      colonia: this.Mastrack.get('colonia')?.value,
      otraColonia: '', // si manejas “otra colonia” aparte, cámbialo aquí
      delegacion: this.Mastrack.get('delegacion')?.value,
      ciudad: this.Mastrack.get('ciudad')?.value,
      estado: this.Mastrack.get('estado')?.value,

      ladaCasa: '', // sin control definido
      telCasa: this.Mastrack.get('tel')?.value,
      ladaCel: '', // sin control definido
      telCel: this.Mastrack.get('teL2')?.value,
      email: this.Mastrack.get('email')?.value,

      idCotizacion: this.quotationId,
      tipo: 'ARIZA',
    };
    observables.push(this.staticPageService.upsertAdminAriza(body));

    return observables;
  }

  public async saveAllData(): Promise<void> {
    const observables = this.buildUpdateRequests(this.quotationId);

    if (observables.length === 0) return;

    try {
      await this.generalService.getServices(observables);
      this.generalService.viewSnacAlert('Datos actualizados', 'normal', 'Completado');
    } catch (err) {
      console.error('❌ Error al guardar datos:', err);
    }
  }
}
